import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// naya thunk — YouTube ka free oEmbed API use karta hai, koi API key nahi chahiye
export const fetchVideoMeta = createAsyncThunk(
  'ytThumbnail/fetchVideoMeta',
  async (videoId, { rejectWithValue }) => {
    try {
      const res = await fetch(
        `https://www.youtube.com/oembed?url=https://youtube.com/watch?v=${videoId}&format=json`
      )
      if (!res.ok) throw new Error('Video not found or private')
      return await res.json() // { title, author_name, author_url, thumbnail_url }
    } catch (err) {
      return rejectWithValue(err.message)
    }
  }
)

const initialState = {
  url: '',
  videoId: '',
  thumbnails: [],
  sceneThumbnails: [],   // NAYA
  status: 'idle', // 'idle', 'loading', 'success', 'error'
  error: null,
  videoMeta: null,     // NAYA — { title, author_name, author_url, thumbnail_url }
  metaStatus: 'idle',  // NAYA — 'idle', 'loading', 'succeeded', 'failed'
}


const ytThumbnailSlice = createSlice({
  name: 'ytThumbnail',
  initialState,
  reducers: {
    setUrl: (state, action) => {
      state.url = action.payload
      state.error = null
    },
    extractVideoId: (state) => {
      if (!state.url.trim()) {
        state.videoId = ''
        state.thumbnails = []
        state.sceneThumbnails = []
        state.status = 'idle'
        return
      }

      // Extract video ID from various YouTube URL formats
      const patterns = [
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([^&\n?#]+)/,
        /youtube\.com\/watch\?.*v=([^&\n?#]+)/,
      ]

      let videoId = ''
      for (const pattern of patterns) {
        const match = state.url.match(pattern)
        if (match && match[1]) {
          videoId = match[1]
          break
        }
      }

      state.videoId = videoId

      if (videoId) {
        state.status = 'success'
        state.thumbnails = [
          {
            quality: 'Max Resolution (1280x720)',
            url: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
            id: 'maxresdefault',
          },
          {
            quality: 'High Quality (480x360)',
            url: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
            id: 'hqdefault',
          },
          {
            quality: 'Medium Quality (320x180)',
            url: `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`,
            id: 'mqdefault',
          },
          {
            quality: 'Standard Quality (120x90)',
            url: `https://img.youtube.com/vi/${videoId}/sddefault.jpg`,
            id: 'sddefault',
          },
        ]
        state.sceneThumbnails = [
          { id: 'scene0', label: 'Scene 1', url: `https://img.youtube.com/vi/${videoId}/0.jpg` },
          { id: 'scene1', label: 'Scene 2', url: `https://img.youtube.com/vi/${videoId}/1.jpg` },
          { id: 'scene2', label: 'Scene 3', url: `https://img.youtube.com/vi/${videoId}/2.jpg` },
          { id: 'scene3', label: 'Scene 4', url: `https://img.youtube.com/vi/${videoId}/3.jpg` },
        ]
      } else {
        state.status = 'error'
        state.error = 'Invalid YouTube URL'
        state.thumbnails = []
      }
    },
    setLoading: (state) => {
      state.status = 'loading'
    },
    setError: (state, action) => {
      state.status = 'error'
      state.error = action.payload
      state.thumbnails = []
    },
    clearThumbnailState: (state) => {
      state.url = ''
      state.videoId = ''
      state.thumbnails = []
      state.sceneThumbnails = []   // NAYA
      state.status = 'idle'
      state.error = null
      state.videoMeta = null    // NAYA
      state.metaStatus = 'idle' // NAYA
    },
  },
  // NAYA BLOCK — fetchVideoMeta thunk ke 3 states handle karta hai
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideoMeta.pending, (state) => {
        state.metaStatus = 'loading'
      })
      .addCase(fetchVideoMeta.fulfilled, (state, action) => {
        state.metaStatus = 'succeeded'
        state.videoMeta = action.payload
      })
      .addCase(fetchVideoMeta.rejected, (state) => {
        state.metaStatus = 'failed'
        state.videoMeta = null
      })
  },
})

export const {
  setUrl,
  extractVideoId,
  setLoading,
  setError,
  clearThumbnailState,
} = ytThumbnailSlice.actions

export default ytThumbnailSlice.reducer